import * as React from 'react';

import withWindowActions, { IWindowDispatchProps } from './withWindowActions';

type Props = IWindowDispatchProps;

export class SizeTracker extends React.Component<Props> {
  public componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    window.addEventListener('orientationchange', this.reload);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    window.removeEventListener('orientationchange', this.reload);
  }

  public reload = () => {
    window.location.reload();
  };

  public handleWindowSizeChange = () => {
    document.body.style.zoom = '1.0';
    this.props.updateSize({
      height: window.innerWidth,
      width: window.innerWidth
    });
  };

  public render() {
    return null;
  }
}

export default withWindowActions(SizeTracker);



// WEBPACK FOOTER //
// ./src/components/SizeTracker/SizeTracker.tsx